import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit, signal, viewChild, ViewChild } from '@angular/core';
import {
  DataService as CoreDataService,
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectModel,
  Query,
  QueryColumn,
  QueryColumnSortOrder,
  QueryObjectsModel,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';
import {
  AbcContextMenuComponent,
  AbcDateBoxComponent,
  AbcGridComponent,
  AbcNumberBoxComponent,
  AbcPopupComponent,
  AbcSpeedDialActionComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcContextMenuComponent,
  _AbcFormComponent,
  _AbcGridComponent,
  _AbcTagBoxComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { UserService } from '@barthauer/basys/core/authentication';
import { DefaultIcons, ObjectTypes, Person, Project, Property, ROLES } from '@barthauer/custom/xmt-models';
import {
  DxButtonModule,
  DxContextMenuModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxFormModule,
  DxPopupModule,
  DxSpeedDialActionModule,
  DxTagBoxModule,
  DxTileViewModule,
} from 'devextreme-angular';
import { DxiItemModule } from 'devextreme-angular/ui/nested';
import { DataSource } from 'devextreme/common/data';
import { Column } from 'devextreme/ui/data_grid';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { of, Subscription } from 'rxjs';
import { NotificationMessage, ActionType, PermissionContext, ToastType } from '../models/enumeration-list.model';
import { AppService } from '../services/app.service';
import { DataService, ObjectKeys } from '../services/data.service';
import { NotificationService } from '../services/notification.service';
import { SharedModule } from '../shared/shared.module';
import { first, map, switchMap } from 'rxjs/operators';
import { CheckPermissionDirective } from '../directives/check-permession-directive';
import { HomeService } from './home.service';
import { SelectionChangedEvent } from 'devextreme/ui/tag_box';
import { UbtLoaderComponent } from '../shared/ubt-loader/ubt-loader.component';
export class IProject extends Project {
  NotificationReminderDays?: Property[];
  NotificationReminderDaysValue?: number;
}
@Component({
  selector: 'ubt-geods-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FlexLayoutModule,
    DxPopupModule,
    DxTileViewModule,
    DxContextMenuModule,
    DxSpeedDialActionModule,
    AbcSpeedDialActionComponent,
    _AbcButtonComponent,
    DxTagBoxModule,
    DxButtonModule,
    DxiItemModule,
    DxDateBoxModule,
    SharedModule,
    _AbcGridComponent,
    DxDataGridModule,
    AbcDateBoxComponent,
    AbcTextBoxComponent,
    DxFormModule,
    _AbcFormComponent,
    AbcPopupComponent,
    _AbcTextAreaComponent,
    _AbcContextMenuComponent,
    CheckPermissionDirective,
    AbcNumberBoxComponent,
    _AbcTagBoxComponent,
    UbtLoaderComponent
  ],
  providers:[HomeService]
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('form') form: _AbcFormComponent;
  @ViewChild('createProjectpopup') createProjectpopup: AbcPopupComponent;
  @ViewChild('deleteProjectpopup') deleteProjectpopup: AbcPopupComponent;
  @ViewChild('deleteContextMenu') deleteContextMenu: AbcContextMenuComponent;
  @ViewChild('contextMenu') contextMenu: _AbcContextMenuComponent;
  @ViewChild('projectGrid') projectGrid: AbcGridComponent;
  private membersTagBox = viewChild<_AbcTagBoxComponent>('MembersTagBox');
  private readonly homeService = inject(HomeService);

  public userName: string;
  private subscriptions: Subscription[] = [];
  public projectList: IProject[] = [];
  public isUpdating: boolean;
  public filtredSubprojects: DataSource;
  public project = new IProject(null);
  public reminderDays: number;
  public oldValueOfStartDate = new Date();
  public oldValueOfEndDate = new Date();
  public oldValueOfDesignation = '';
  public oldValueOfState = '';
  public oldValueOfDescription = '';
  public oldValueOfNotificationReminderDays = 0;
  public title = this.dataService.res('Ubt-Project-Create');
  public projectTitle: string;
  public mesureTaskLabel: string;
  public Action = ActionType;
  public PermissionContext = PermissionContext;
  public noDataText = this.dataService.res('Ubt-No-Data-text');
  public filterPanelLabel = this.dataService.res('Ubt-Filter-Project');
  public projectColumns = [
    this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Designation', 'Designation', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('ref:ParentId', 'ParentAddress', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('SysDateInsert', 'Date', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Subject', 'Description', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('StartDate', 'StartDate', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('EndDate', 'EndDate', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('State', 'State', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Count(subProjects)', 'subProjectsCount', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Count(subProjects.Measures)', 'measuresCount', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn(
      'Count(subProjects.Measures.MeasureTasks)',
      'tasksCount',
      QueryColumnSortOrder.None,
    ),
  ];

  public columnsHeader: Column[] = [
    {
      caption: this.dataService.res('Ubt-Project-Name'),
      dataField: 'Designation',
      dataType: 'string',
      visibleIndex: 0,
      hidingPriority: 6,
    },
    {
      caption: this.dataService.res('Ubt-MeasureDetail-Description'),
      dataField: 'Description',
      dataType: 'string',
      visibleIndex: 1,
      hidingPriority: 5,
    },
    {
      caption: this.dataService.res('Ubt-Measure-List-StartDate'),
      dataField: 'StartDate',
      dataType: 'date',
      visibleIndex: 2,
      hidingPriority: 4,
    },
    {
      caption: this.dataService.res('Ubt-MeasureTask-State'),
      dataField: 'State',
      dataType: 'number',
      alignment: 'left',
      visibleIndex: 3,
      hidingPriority: 3,
    },
    {
      caption: this.dataService.res('Ubt-Measure-List-EndDate'),
      dataField: 'EndDate',
      dataType: 'date',

      visibleIndex: 4,
      hidingPriority: 2,
    },
    {
      type: 'buttons',
      caption: '',
      alignment: 'left',
      dataField: '',
      visibleIndex: 5,
      minWidth: 50,
      width: '50px',
      hidingPriority: 1,
    },
  ];

  public createButtonOptions = {
    text: this.dataService.res('Ubt-CreateMeasure-Create'),
    useSubmitBehavior: true,
  };
  public updateButtonOptions = {
    text: this.dataService.res('Ubt-CreateMeasure-Update'),
    useSubmitBehavior: true,
  };
  public cancelButtonOptions = {
    text: this.dataService.res('Ubt-CreateMeasure-Cancel'),
    onClick: () => {
      this.closeCreatePopUp();
    },
  };
  public contextMenuItems: any[] = [
    {
      text: this.dataService.res('Ubt-Roles-Edit-Project'),
      onClick: (event) => {
        this.openProjectDialog();
      },
    },
    {
      text: this.dataService.res('Ubt-Roles-Delete-Project'),
      onClick: (event) => {
        this.openDeleteProjectDialog(event);
      },
    },
  ];

  public readonly exportFileName =
    this.dataService.res('Ubt-TreeList-Project') + '_' + this.datePipe.transform(new Date(), 'dd.MM.yyyy');
  
  protected members : Person[]=[];
  protected projectMembers: string[] = [];
  protected isLoading = signal(false);
  protected updateProjectInfoMessage = this.dataService.res("Ubt-Project-Associate-Admin-Update-Message");
  protected createProjectInfoMessage = this.dataService.res("Ubt-Project-Associate-Admin-Create-Message");
  
  private newAssociatedMembersIds: string[]=[];
  private newDissociatedMembersIds: string[]=[];
  private skipSelection = false;
  constructor(
    private coreDataService: CoreDataService,
    private userService: UserService,
    public dataService: DataService,
    private appService: AppService,
    private persistenceService: PersistenceService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private notificationService: NotificationService,
  ) {
    this.projectTitle = this.dataService.res('Ubt-TreeList-Project');
    this.mesureTaskLabel = this.dataService.res('Ubt-MeasureTask-Label');
    this.filterPanelLabel = this.dataService.res('Ubt-Filter-Project');
  }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.dataService.updateGridData$.subscribe((companyId) => {
        this.getProjectsData(companyId);
      }),
    );

    if (sessionStorage.getItem('profileAddressId')) {
      this.getProjectsData(sessionStorage.getItem('profileAddressId'));
    }
    this.initializeMembers();
  }

  public onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.style.cursor = 'pointer';
      e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
    }
  }

  public onCellClick(e) {
    if (e.column?.command === 'adaptive') {
      e.event?.stopPropagation();
      return;
    }
    this.project = e.data;
    this.project.NotificationReminderDaysValue = this.project.NotificationReminderDays?.[0]?.LongValue;
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.className = 'context-menu-icon' + e.rowIndex;
      e.cellElement.innerHTML = this.contextMenu.visible ? DefaultIcons.CLOSE : DefaultIcons.CONTEXTMENU;
      this.contextMenuItems[0].visible = this.dataService.hasPermission(PermissionContext.Project, ActionType.UPDATE);
      this.contextMenuItems[1].visible = this.dataService.hasPermission(PermissionContext.Project, ActionType.DELETE);
      this.contextMenu.target = '.context-menu-icon' + e.rowIndex;
      this.contextMenu.instance.show();
    }
  }

  private getProjectsData(companyId: string) {
    this.appService.showLoader(true);
    const adminOpath=this.dataService.getRole()=== ROLES.ADMIN ?'': `AND Exists(MemberPersons[IdRefPerson='${sessionStorage.getItem('profileId')}'])`;
    const opath = `ParentId='${companyId}' ${adminOpath}`;

    const project: Query = new Query();
    project.Columns = this.projectColumns;
    project.ObjectType = ObjectKeys.PROJECT;
    project.OPath = opath;
    const projectReminder: Query = new Query();
    projectReminder.ObjectType = ObjectKeys.PROPERTY;
    projectReminder.Name = 'NotificationReminderDays';
    projectReminder.OPath = "Properties[Designation like 'NotificationReminderDays']";
    const projectReminderColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('Designation', 'Designation'),
      this.coreDataService.createQueryColumn('LongValue', 'LongValue'),
    ];
    projectReminder.Columns = projectReminderColumns;
    project.ObjectQueries = [projectReminder];
    const queryObjectModel = new QueryObjectsModel();
    queryObjectModel.ObjectQueries = [project];
    return this.coreDataService.executeReadObjectsQuery(queryObjectModel).subscribe(
      (projects) => {
        if (Array.isArray(projects) && projects.length > 0) {
          this.projectList = projects;
        } else {
          this.projectList = [];
          this.notificationService.callNotification({
            message: NotificationMessage.Empty,
            type: ToastType.INFO,
          });
        }
      },
      (error) => {
        console.error(error);
        this.appService.showLoader(false);
        this.cdr.markForCheck();
      },
      () => {
        this.appService.showLoader(false);
        this.cdr.markForCheck();
      },
    );
  }

  public openDeleteProjectDialog(event): void {
    this.deleteProjectpopup.instance.show();
  }

  public openProjectDialog() {
    this.isUpdating = true;
    this.title = this.dataService.res('Ubt-Project-Update');
    this.cdr.markForCheck();
    this.oldValue(true);
  }

  public oldValue(isUpdate?: boolean): void {
    this.appService.showLoader(true);
    this.isUpdating = isUpdate;
    this.oldValueOfDesignation = this.project.Designation;
    this.oldValueOfStartDate = this.project.StartDate;
    this.oldValueOfEndDate = this.project.EndDate;
    this.oldValueOfState = this.project.State;
    this.oldValueOfDescription = this.project.Description;
    this.oldValueOfNotificationReminderDays = this.project.NotificationReminderDays?.[0]?.LongValue;
    this.homeService.getAssociatedMembers(this.project.Id).pipe(first()).subscribe({
      next:(persons)=>{
        this.homeService.associatedMembers= persons;
        if(persons.length>0)this.skipSelection=true;
        this.projectMembers = persons.map((person)=>person.Id);
        this.cdr.detectChanges();
      },
      error:()=>{
        this.notificationService.callNotification({
          message: NotificationMessage.Error,
          type: ToastType.ERROR,
        });
      },
      complete:()=>{
        this.appService.showLoader(false);
        this.createProjectpopup.instance.show();
      }
    })
  }

  public confirmRemoveProject(e): void {
    this.subscriptions.push(
      this.dataService.deleteObject(ObjectKeys.PROJECT, this.project.Id).subscribe(
        () => {
          this.notificationService.callNotification({
            message: NotificationMessage.ValidDeleteMessage,
            type: ToastType.SUCCESS,
          });
          const index = this.projectList.findIndex((item) => item.Id === this.project.Id);
          this.projectList.splice(index, 1);
          this.deleteProjectpopup.instance.hide();
        },
        (error) => {
          console.error(error);
          this.notificationService.callNotification({
            message: NotificationMessage.Error,
            type: ToastType.ERROR,
          });
        },
        () => {
          this.cdr.markForCheck();
        },
      ),
    );
  }

  public abort(): void {
    this.project.Id = undefined;
    this.deleteProjectpopup.instance.hide();
  }

  public openCreateProject() {
    this.isUpdating = false;
    this.createProjectpopup.instance.show();
    this.project = new Project(null);
  }

  public createProject(e) {
    if (this.isUpdating === false) {
      e.preventDefault();
      this.persistProject(PersistMode.Insert);
    } else {
      this.persistProject(PersistMode.Update);
      e.preventDefault();
    }
  }

  private persistProject(mode: PersistMode): void {
    const projectPersistQuery: TargetObjectData = new TargetObjectData();
    projectPersistQuery.ObjectKey = new ObjectKey();
    projectPersistQuery.ObjectKey.ObjectType = ObjectKeys.PROJECT;
    const projectColumns: TargetColumnValue[] = [
      { Name: 'ParentId', Value: sessionStorage.getItem('profileAddressId') },
      { Name: 'Designation', Value: this.project.Designation },
      { Name: 'Subject', Value: this.project.Description },
      {
        Name: 'StartDate',
        Value: this.datePipe.transform(this.project.StartDate, 'yyyy-MM-dd'),
      },
      {
        Name: 'EndDate',
        Value: this.datePipe.transform(this.project.EndDate, 'yyyy-MM-dd'),
      },
      { Name: 'State', Value: this.project.State },
    ];
    if (mode == PersistMode.Update) projectPersistQuery.ObjectKey.Id = this.project.Id;
    projectPersistQuery.Mode = mode;
    projectPersistQuery.TargetColumns = projectColumns;
    const persistObject: PersistObjectModel = new PersistObjectModel();
    persistObject.Object = projectPersistQuery;
    this.isLoading.set(true);
    this.persistenceService
      .executePersistObjectQuery(persistObject)
      .pipe(
        switchMap((data: any) => {
          return this.updateProjectNotificationReminderDays(
            data.Id,
            this.project?.NotificationReminderDays?.[0]?.Id,
          ).pipe(map(() => data?.Id));
        }),
      ).pipe(
        switchMap(result =>
          this.homeService.manageProjectMembers(result,this.newAssociatedMembersIds,this.newDissociatedMembersIds).pipe(
            map(() => result)
          )
        )
      )
      .pipe(first())
      .subscribe({
        next: (data: any) => {
          if (!this.isUpdating) {
            this.getLatestProject(data);
          }
          if (this.project.NotificationReminderDays?.length) {
            this.project.NotificationReminderDays[0].LongValue = this.project.NotificationReminderDaysValue;
          }
          this.notificationService.callNotification({
            message: NotificationMessage.ValidInsertMessage,
            type: ToastType.SUCCESS,
          });
        },
        error: (error) => {
          this.isLoading.set(false);
          this.notificationService.callNotification({
            message: NotificationMessage.Error,
            type: ToastType.ERROR,
          });
        },
        complete: () => {
          this.isLoading.set(false);
          this.closeCreatePopUp();
          this.project = new Project(null);
        },
      });
  }

  updateProjectNotificationReminderDays(projectId: string, propertyId?: string) {
    const commentColumns: TargetColumnValue[] = [
      { Name: 'Designation', Value: 'NotificationReminderDays' },
      { Name: 'ParentId', Value: projectId },
      { Name: 'ParentObjectType', Value: ObjectTypes.PROJECT },
      { Name: 'LongValue', Value: this.project.NotificationReminderDaysValue },
      { Name: 'Type', Value: 'NotificationReminderDays' },
    ];
    const propertyPersistQuery: TargetObjectData = new TargetObjectData();
    propertyPersistQuery.ObjectKey = new ObjectKey();
    propertyPersistQuery.ObjectKey.ObjectType = ObjectKeys.PROPERTY;
    propertyPersistQuery.TargetColumns = commentColumns;
    propertyPersistQuery.TargetColumns;
    const persistObject: PersistObjectModel = new PersistObjectModel();
    persistObject.Object = propertyPersistQuery;

    if (propertyId) {
      propertyPersistQuery.Mode = PersistMode.Update;
      propertyPersistQuery.ObjectKey.Id = propertyId;
    } else {
      propertyPersistQuery.Mode = PersistMode.Insert;
    }

    const persistPropertyObject: PersistObjectModel = new PersistObjectModel();
    persistPropertyObject.Object = propertyPersistQuery;
    return this.coreDataService.executePersistObjectQuery(persistPropertyObject);
  }

  public getLatestProject(id: string): void {
    this.appService.showLoader(true);
    const opath = `Id='${id}'`;

    const project: Query = new Query();
    project.Columns = this.projectColumns;
    project.ObjectType = ObjectKeys.PROJECT;
    project.OPath = opath;
    const projectReminder: Query = new Query();
    projectReminder.ObjectType = ObjectKeys.PROPERTY;
    projectReminder.Name = 'NotificationReminderDays';
    projectReminder.OPath = "Properties[Designation like 'NotificationReminderDays']";
    const projectReminderColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('Designation', 'Designation'),
      this.coreDataService.createQueryColumn('LongValue', 'LongValue'),
    ];
    projectReminder.Columns = projectReminderColumns;
    project.ObjectQueries = [projectReminder];
    const queryObjectModel = new QueryObjectsModel();
    queryObjectModel.ObjectQueries = [project];

    this.coreDataService.executeReadObjectsQuery(queryObjectModel).subscribe(
      (projectData) => {
        this.projectList.push(projectData[0]);
        this.cdr.markForCheck();
      },
      (error) => {
        console.error(error);
        this.appService.showLoader(false);
      },
      () => {
        this.appService.showLoader(false);
      },
    );
  }
  protected clearPopup(){
    if (this.isUpdating) {
      this.project.Designation = this.oldValueOfDesignation;
      this.project.Description = this.oldValueOfDescription;
      this.project.State = this.oldValueOfState;
      this.project.StartDate = this.oldValueOfStartDate;
      this.project.EndDate = this.oldValueOfEndDate;
      this.project.NotificationReminderDaysValue = this.oldValueOfNotificationReminderDays;
    }
    this.isUpdating = false;
    this.project = new Project(null);
    this.isUpdating = false;
    this.form.instance.resetValues();
    this.title = this.dataService.res('Ubt-Project-Create');
    this.resetAssociatedMembersValues();
  }
  protected addRemoveMember(e:SelectionChangedEvent):void{
    if(this.skipSelection){
      this.skipSelection=false;
      return;
    }
    e.addedItems.forEach((person)=>{
      if(!this.homeService.associatedMembers.find((member)=>member.Id===person.Id))
        this.newAssociatedMembersIds.push(person.Id);
    });
    e.removedItems.forEach(person=>{
      const member=this.homeService.associatedMembers.find((member)=>member.Id===person.Id);
      if(member)
        this.newDissociatedMembersIds.push(member['ProjectPerson'].Id);
      else
        this.newAssociatedMembersIds=this.newAssociatedMembersIds.filter(id=> id!=person.Id);
    });
  }
  private initializeMembers():void{
    this.homeService.getAllMembers().pipe(first()).subscribe({
      next: (members)=>{
        if(Array.isArray(members)){
          this.members=members
        }
      },
      error:()=>{
        this.notificationService.callNotification({
          message: NotificationMessage.Error,
          type: ToastType.ERROR,
        })
      }
    })
  }
  private closeCreatePopUp() {
    this.createProjectpopup.instance.hide();
  }
  private resetAssociatedMembersValues():void{
    this.homeService.associatedMembers = [];
    if(this.projectMembers.length>0) this.skipSelection=true;
    this.membersTagBox().instance.reset();
    this.newAssociatedMembersIds=[];
    this.newDissociatedMembersIds=[];
  }
  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }
}
